import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, X } from "lucide-react";
import { getBreaking } from "@/lib/api";
import { articlePath } from "@/lib/readoo";

const DISMISS_KEY = "readoo_breaking_dismissed";

export function BreakingBanner() {
  const [item, setItem] = useState(null);

  useEffect(() => {
    let alive = true;
    getBreaking()
      .then((r) => {
        if (!alive) return;
        const b = r?.breaking;
        if (!b) return;
        let dismissed = "";
        try { dismissed = localStorage.getItem(DISMISS_KEY) || ""; } catch {}
        if (dismissed !== b.article_id) setItem(b);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!item) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, item.article_id); } catch {}
    setItem(null);
  };

  return (
    <div data-testid="breaking-banner" className="text-white" style={{ backgroundColor: "#d30000" }}>
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] font-bold uppercase tracking-wider shrink-0">
          <Zap size={14} className="fill-white" /> Breaking
        </span>
        <Link to={articlePath(item)} data-testid="breaking-banner-link" className="text-sm font-medium truncate hover:underline flex-1">
          {item.title}
        </Link>
        <button data-testid="breaking-banner-close" onClick={dismiss} aria-label="Chiudi" className="shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
